<template>
  <!-- 数据统计时间筛选组件 -->
  <div>
    <div class="box">
      <blue-title class="style">经营者/法人身份证件</blue-title>
      <div>
        <div class="info"><span class="marRight">证件类型</span><span>身份证</span></div>
        <div class="info" style="height: 70px">
          <span class="marRight">身份证人像面照片</span
          ><span
            ><el-image :src="subjectData.idCardInfoIdCardCopy" alt="" style="width: 58px; height: 58px"></el-image
          ></span>
        </div>
        <div class="info" style="height: 70px">
          <span class="marRight">身份证国徽面照片</span
          ><span
            ><el-image :src="subjectData.idCardInfoIdCardNational" alt="" style="width: 58px; height: 58px"></el-image
          ></span>
        </div>
        <div class="info">
          <span class="marRight">受益人姓名</span><span>{{ subjectData.name }}</span>
        </div>
        <div class="info">
          <span class="marRight">证件号码</span><span>{{ subjectData.idNumber }}</span>
        </div>
        <div class="info"><span class="marRight">证件有效期类型</span><span>------</span></div>
        <div class="info">
          <span class="marRight">有效期限开始日期</span><span>{{ subjectData.idPeriodBegin }}</span>
        </div>
        <div class="info">
          <span class="marRight">有效期限结束日期</span><span>{{ subjectData.idPeriodEnd }}</span>
        </div>
        <div class="info"><span class="marRight">是否为受益人</span><span>------</span></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    subjectData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },

  watch: {},

  methods: {},
};
</script>

<style lang="less" scoped>
.box {
  background-color: white;
  box-sizing: border-box;
  height: 100%;

  .info {
    display: flex;
    align-items: center;
    font-size: 12px;
    color: #333;
    font-weight: 500;
    height: 42px;
    border-bottom: 1px solid #e5e5e5;
  }
  .style {
    font-size: 12px;
    color: #333;
    font-weight: 500;
    margin: 18px 0 11px 0;
  }
  .marRight {
    width: 100px;
    margin-right: 38px;
  }
}
</style>
